/**
 * 
 * key
 * 
 */


const key = 'cHJpbnRQbFByaW50Q29tcGxldGVk'

export default key 